import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Button,
  Loader,
  Icon,
  Modal
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { getActivityIntervalTypeLabel, getAuthActionLabel, getAuthProviderLabel, getWorkStatusLabel } from '../../helpers/user';
import { reportActions } from '../../actions/report.actions';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class ActivityIntervalScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        search: '',
        startDate: null,
        endDate: null,
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

   handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, search, period } = this.state;
    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
        startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
        endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }
  
    dispatch(reportActions.fetchActivityIntervals({ page, search, startDate, endDate, orderBy: "StartTime", export: isExport ? true : null, ascending: false }));
  }

  handleChange(field, data) {    
    const state = this.state;    
    state[field] = data;    
    this.setState(state);    
    this.handleSearchDebounced();
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;    

    return (
      <Fragment>
        <Header>
          <h1>Sessões e Bloqueios</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
                          name="period"
                          localization="pt-br"
                          placeholder="Período"
                          value={period}
                          iconPosition="left"
                          dateFormat={DATE_FORMAT}
                          label='Período'
                          closable={true}
                          clearable={true}
                          onChange={(e, data) => this.handlePeriodChange(data.value)}
                        />
            <Form.Input icon='search' label='Username' onChange={(e, data) => this.handleChange("search", data.value)} loading={loading} />            
            
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> Exportar
            </Form.Button>            
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>                                      
                    <Table.HeaderCell>Usuário</Table.HeaderCell>                    
                    <Table.HeaderCell>Username</Table.HeaderCell>
                    <Table.HeaderCell>E-Mail</Table.HeaderCell>                                  
                    <Table.HeaderCell>Máquina</Table.HeaderCell>                    
                    <Table.HeaderCell>Atividade</Table.HeaderCell>
                    <Table.HeaderCell>Início</Table.HeaderCell>                    
                    <Table.HeaderCell>Término</Table.HeaderCell>                    
                    <Table.HeaderCell>Tempo Total</Table.HeaderCell>                    
                </Table.Row>
            </Table.Header>
            <Table.Body>              
                { registers && registers.Results && registers.Results.map((register) => {
                    return <Table.Row key={register.Id}>                 
                        <Table.Cell>{register.User.Name}</Table.Cell>    
                        <Table.Cell>{register.User.Username}</Table.Cell>                           
                        <Table.Cell>{register.User.Email}</Table.Cell>              
                        <Table.Cell>{register.ComputerName}</Table.Cell>               
                        <Table.Cell>{getActivityIntervalTypeLabel(register.Type)}</Table.Cell>               
                        <Table.Cell>{moment(register.StartTime).format("DD/MM/YYYY HH:mm:ss")}</Table.Cell>               
                        <Table.Cell>{register.EndTime ? moment(register.EndTime).format("DD/MM/YYYY HH:mm:ss") : '-'}</Table.Cell>               
                        <Table.Cell>{moment.duration(register.DurationSeconds, "seconds").format("HH:mm", { trim: false })}</Table.Cell>               
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;  

  
  return {
    registers: report?.activityInterval || null,
    loading: report?.activityInterval?.loading
  };
}

const connectedActivityIntervalScreen = connect(mapStateToProps)(ActivityIntervalScreen);
export { connectedActivityIntervalScreen as ActivityIntervalScreen };
